import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router";
import axios from "axios";

const WebhookUrl = ({ webhookSettings }) => {
  const [formData, setFormData] = useState({
    userId: "",
    url: "",
    enabled: false
  });

  const apiKey = process.env.REACT_APP_API_KEY;
  const auth = getAuth();
  const navigate = useNavigate();
  const [isEnabled, setIsEnabled] = useState(
    webhookSettings?.enabled 
  );
  const [userId, setUserId] = useState(null)
  useEffect(() => {
    if (webhookSettings) {
      setFormData((prev) => ({
        ...prev,
        url: webhookSettings.url || "",
        enabled: webhookSettings.enabled || false,
      }));
      setIsEnabled(webhookSettings.enabled || false);
    }
  }, [webhookSettings]);
  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const key in formData) {
      if (!formData[key]) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Please fill in all fields.",
        });
        return;
      }
    }

    const apiUrl = "https://api.v1.spotyourleads.com/user/set-and-test-webhook";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Form submitted successfully!",
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text:
            result?.message ||
            "Failed to submit the form. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while submitting the form.",
      });
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid)
        setFormData((prev) => ({
          ...prev,
          userId: user.uid,
          url: prev.url || webhookSettings?.url || "",
        }));
      } else {
        navigate("/sign-in");
      }
    });

    return () => unsubscribe();
  }, [auth, navigate, webhookSettings?.url]);
  const sendDataToAPI = async (data) => {
    const apiUrl = "https://api.v1.spotyourleads.com/user/set-and-test-webhook";
  
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
        body: JSON.stringify(data),
      });
  
      const result = await response.json();
  
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Webhook updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text:
            result?.message ||
            "Failed to update the webhook. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error updating webhook:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while updating the webhook.",
      });
    }
  };
  

  const handleToggle = () => {
    const newValue = !isEnabled;
    setIsEnabled(newValue);
  
    const updatedFormData = {
      ...formData,
      enabled: newValue,
    };
  
    setFormData(updatedFormData);
  
    if (!newValue) {
      sendDataToAPI(updatedFormData);
    }
  };
  
  return (
    <>
      <section className="homeFourth formSection account ">
        <div className="about">
          <Container>
            <div className="pricing-title">
              <h2> Webhook URL</h2>
            </div>
            
          </Container>
        </div>
        <Container>
         <div className="d-flex a align-items-center justify-content-between auto-leads">
              <h3 className="text-xl font-semibold text-gray-800 ">
                Enable Auto Purchase
              </h3>
              <Form.Check
                type="switch"
                id="auto-purchase-switch"
                checked={isEnabled}
                className="custom-switch"
                onChange={handleToggle}
              />
            </div>
       {isEnabled && (
<>
          <Row className="leads-form">
            <Col lg={12}>
              <div className="formDiv">
                <form onSubmit={handleSubmit}>
                  <h3>Url</h3>
                  <input
                    type="text"
                    className="form-control"
                    name="url"
                    value={formData.url}
                    onChange={handleChange}
                  />
                  <br />

                  <button type="submit">Save</button>
                </form>
              </div>
            </Col>
          </Row>
          </>
          )}
        </Container>
      </section>
    </>
  );
};

export default WebhookUrl;
